export default __webpack_public_path__ + "static/media/lack-of-bleeding-ON.decc3397.png";